/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APILanguageEnum {
    de = 'de',
    en = 'en'
}


export function instanceOfAPILanguageEnum(value: any): boolean {
    for (const key in APILanguageEnum) {
        if (Object.prototype.hasOwnProperty.call(APILanguageEnum, key)) {
            if (APILanguageEnum[key as keyof typeof APILanguageEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APILanguageEnumFromJSON(json: any): APILanguageEnum {
    return APILanguageEnumFromJSONTyped(json, false);
}

export function APILanguageEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APILanguageEnum {
    return json as APILanguageEnum;
}

export function APILanguageEnumToJSON(value?: APILanguageEnum | null): any {
    return value as any;
}

